    var wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
    var countWishlist = wishlist.length;
    console.log("hay " + countWishlist + " items en la wishlist (al entrar)");

    function printWishlistCount(numberOfProductsInWishlist) {
      var wishlistCounter = $('.the-wishlist-counter');
      $(wishlistCounter).text(numberOfProductsInWishlist);
      console.log("la funcion printWishlist se ha tirado con " + numberOfProductsInWishlist + " elementos y el contenedor es " + wishlistCounter[0]);
    }

    function itemInWishlist(productID){
      var wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
      var elementwl = wishlist.find(elementwl => elementwl.productID === productID);
      var BUTTON_CLASS_IN_WISHLIST = 'in-wishlist';
      var buttonWishlist = document.getElementById('wishlist-' + productID);
      var buttonWishlistMobile = document.getElementById('wishlist-mobile-' + productID);
      var imgbutton = buttonWishlist.getElementsByClassName("icon-heart")[0];
      var imgbuttonmobile = buttonWishlist.getElementsByClassName("icon-heart-movil")[0];
      if(elementwl){
        $(buttonWishlist).addClass(BUTTON_CLASS_IN_WISHLIST);
      }
      else{
      }
      if($(buttonWishlist).hasClass(BUTTON_CLASS_IN_WISHLIST)){
        $(imgbutton).attr("src","https://cdn.shopify.com/s/files/1/0007/5192/7347/files/heart-fill-red-v4.svg?v=1713080796");
        $(imgbuttonmobile).attr("src","https://cdn.shopify.com/s/files/1/0007/5192/7347/files/heart-fill-red-v4.svg?v=1713080796");
      } else {

      }
    }
    function updateWishlist(variantID, productHandle, productID){
          var BUTTON_CLASS_IN_WISHLIST = 'in-wishlist';
          var buttonWishlist = document.getElementById('wishlist-' + productID);
          var buttonWishlistMobile = document.getElementById('wishlist-mobile-' + productID);
          var imgbutton = buttonWishlist.getElementsByClassName("icon-heart")[0];
          var imgbuttonmobile = buttonWishlist.getElementsByClassName("icon-heart-movil")[0];
          wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
          // Wishlist empty
          if(wishlist.length === 0){
            console.log("wishlist is empty, so adds it. Now it is in the wishlist.");
          // So add item
          addItem2Wishlist(wishlist, variantID, productHandle, productID);
          $(buttonWishlist).addClass(BUTTON_CLASS_IN_WISHLIST);
          countWishlist ++;
          console.log("hay " + countWishlist + " items en la wishlist (después de añadirlo)");
          }
        else{
          // Does wishlist already have this item?
          var elementwl = wishlist.find(elementwl => elementwl.productID === productID);
          // It does
          if(elementwl){
              console.log("wishlist had the item, so removes it. Now it is NOT in the wishlist.");
              removeItemFromWishlist(wishlist, variantID, productHandle, productID);
              $(buttonWishlist).removeClass(BUTTON_CLASS_IN_WISHLIST);
              countWishlist --;
              console.log("hay " + countWishlist + " items en la wishlist (después de quitarlo)");
          } //It doesn't
          else{
              // So add item
            console.log("wishlist did NOT have the item, so adds it. Now it is in the wishlist");
            addItem2Wishlist(wishlist, variantID, productHandle, productID);
            $(buttonWishlist).addClass(BUTTON_CLASS_IN_WISHLIST);
            countWishlist ++;
            console.log("hay " + countWishlist + " items en la wishlist (después de añadirlo)");
          }
        }
      if($(buttonWishlist).hasClass(BUTTON_CLASS_IN_WISHLIST)){
        $(imgbutton).attr("src","https://cdn.shopify.com/s/files/1/0007/5192/7347/files/heart-fill-red-v4.svg?v=1713080796");
        $(imgbuttonmobile).attr("src","https://cdn.shopify.com/s/files/1/0007/5192/7347/files/heart-fill-red-v4.svg?v=1713080796");
      } else {
        $(imgbutton).attr("src","https://cdn.shopify.com/s/files/1/0007/5192/7347/files/heart-svgrepo-com_4.svg?v=1713072453");
        $(imgbuttonmobile).attr("src","https://cdn.shopify.com/s/files/1/0007/5192/7347/files/heart-svgrepo-com_4.svg?v=1713072453");
      }

      printWishlistCount(countWishlist);
    }

    function addItem2Wishlist(wishlist, variantID, productHandle, productID){
      jQuery.getJSON(window.Shopify.routes.root + `products/${productHandle}.js`, function(product) {
        var auxImg = "";
        var variantTitle = "";
        var elementwl = {
          "email": "{{ customer.email }}",
          "productHandle" : productHandle,
          "productID": productID,
          "productTitle": product.title,
          "productPrice": product.price / 100,
          "productURL": "https://artesta.co" + product.url,
          "productImage": auxImg
        }
        wishlist.push(elementwl);
        localStorage.setItem("wishlist", JSON.stringify(wishlist));
      } );
    }
    
    function removeItemFromWishlist(wishlist, variantID, productHandle, productID){
      wishlist = wishlist.filter(function(elementwl) { return elementwl.productID != productID; }); 
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    }
  
  
$(document).ready(function(){
  printWishlistCount(countWishlist);
});

// ===== Wishlist: refresco para infinite scroll (añadir debajo de tu código) =====

// Guarda qué productos ya se han inicializado para no repetir trabajo
var __wlInited = new Set();

// Busca botones "wishlist-<id>" recién añadidos y ejecuta itemInWishlist(<id>)
function refreshWishlistHearts(root) {
  // Evita coger los móviles (los trata itemInWishlist al pintar el principal)
  var selector = '[id^="wishlist-"]:not([id^="wishlist-mobile-"])';
  var scope = root || document;
  var buttons = scope.querySelectorAll(selector);

  buttons.forEach(function(btn){
    var m = btn.id.match(/^wishlist-(.+)$/);
    if (!m) return;
    var pid = m[1]; // puede ser string o número; pasamos tal cual para respetar tu comparación estricta
    if (__wlInited.has(pid)) return; // ya inicializado
    __wlInited.add(pid);
    try { itemInWishlist(pid); } catch(e) { /* si aún no está definida, no romper */ }
  });
}

// 1) Inicializa al cargar
document.addEventListener('DOMContentLoaded', function () {
  refreshWishlistHearts(document);

  // 2) Observa el contenedor de la grid (intenta varios selectores comunes en temas nativos)
  var grid =
    document.querySelector('[data-product-grid]') ||
    document.querySelector('[data-section-type="collection-product-grid"]') ||
    document.querySelector('.collection .product-grid, .collection-grid, .product-grid') ||
    document.body; // último recurso

  // 3) Observa nodos añadidos y refresca SOLO cuando aparecen botones wishlist nuevos
  var rafId = null;
  var mo = new MutationObserver(function(mutations){
    var needs = false;

    for (var i=0; i<mutations.length && !needs; i++){
      var m = mutations[i];
      // Revisa nodos añadidos
      for (var j=0; j<m.addedNodes.length; j++){
        var node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if ((node.id && node.id.indexOf('wishlist-') === 0) ||
            (node.querySelector && node.querySelector('[id^="wishlist-"]'))) {
          needs = true; break;
        }
      }
    }

    if (needs) {
      // Batching con rAF para no refrescar múltiples veces por ráfaga de inserts
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function(){
        rafId = null;
        refreshWishlistHearts(grid);
      });
    }
  });

  mo.observe(grid, { childList: true, subtree: true });
});
